var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Close component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconClose extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.7218 3.85314C22.0927 3.48216 22.0927 2.88067 21.7218 2.50968C21.3508 2.1387 20.7493 2.1387 20.3783 2.50968L12 10.888L3.6217 2.50968C3.25071 2.1387 2.64922 2.1387 2.27824 2.50968C1.90725 2.88067 1.90725 3.48216 2.27824 3.85314L10.6565 12.2314L2.27824 20.6097C1.90725 20.9807 1.90725 21.5822 2.27824 21.9532C2.64922 22.3242 3.25071 22.3242 3.6217 21.9532L12 13.5749L20.3783 21.9532C20.7493 22.3242 21.3508 22.3242 21.7218 21.9532C22.0927 21.5822 22.0927 20.9807 21.7218 20.6097L13.3435 12.2314L21.7218 3.85314Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconClose.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconClose.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconClose.prototype, "size", void 0);
if (customElements.get('cat-icon-close') === undefined) {
    customElements.define('cat-icon-close', BlocksIconClose);
}
